import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Paper, Typography, Box, Link } from '@mui/material';
import FlexBetween from "components/FlexBetween";
import Header from "components/Header";
import getAccessToken from "../state/accessToken"

const DealDetails = () => {
  const location = useLocation();
  const { deal, searchTerm } = location.state;
  console.log("Deal", deal);
  console.log("Term", searchTerm)
  const [driveFiles, setDriveFiles] = useState([]);

  useEffect(() => {
    const searchDrive = async () => {
      const folderIds = [
        '1vZgfNSUxN0xLd-J_CD1mK7-3Ew0bfF7p', // Shopping list
        '1-JSaDMiBtR5LRYk2dB4G4HKGOPKZ1C-S', // Checklist
        '1SGGFE4I1JDYa1XFzKPTwBk2jy8JCt5GQ', // Checklist Sheets
        '1i8UU22lE5OwSi-XB-mwIQDyuufYFcMUr', // Quotes
        '1s5I3_i8rQprCyGdPFzQAT9ybJMYmVRsN'  // Menu
    ];
      
    let files = [];
      for (const folderId of folderIds) {
        const accessToken = await getAccessToken();
        const response = await fetch(`https://www.googleapis.com/drive/v3/files?q='${folderId}'+in+parents and name contains '${searchTerm}'`, {
          headers: {
            'Authorization': `Bearer ${accessToken}`,
          },
        });
        const data = await response.json();
        files.push(...data.files);
      }
      setDriveFiles(files);
    };

    if (searchTerm) {
      searchDrive();
    }
  }, [deal, searchTerm]);

  const valueFormatted = Number.parseFloat(deal.dealValue).toFixed(2);
  
  return (
    <Box>
      <FlexBetween m="1.5rem 2.5rem">
        <Header title="Deal Dossier" subtitle="All you need to know about this deal" />
      </FlexBetween>
      <Paper elevation={3} style={{ padding: '20px', margin: '20px' }}>
          <Typography variant="h4" color="#ffffff" fontWeight="600">{deal.title}</Typography>
          <Typography>Deal ID: {deal.id}</Typography>
          <Typography marginTop="0.5rem">Value: {valueFormatted} €</Typography>
          <Typography>Status: {deal.status}</Typography>
          <Typography marginTop="0.5rem"> 
            <Link
              href={`https://flairflow.salesmate.io/#/app/deals/${deal.id}/detail?source=b61cb4a7-7425-4580-ad01-5d7fde846d70`}
              target="_blank"
              rel="noopener noreferrer"
            sx={{
                color: '#f77777', 
                textDecoration: 'underline',
              }}
            >
            See it on Salesmate
            </Link>
          </Typography>
      </Paper>
      <FlexBetween m="0rem 2.5rem">
        <Header title="" subtitle="Related Files" />
      </FlexBetween>
      <Paper style={{ padding: '20px', margin: '20px' }}>
        {driveFiles.map(file => (
          <Typography key={file.id} variant="body1" gutterBottom>
            <Link 
              href={`https://drive.google.com/file/d/${file.id}/view`} 
              target="_blank" 
              rel="noopener noreferrer"
              sx={{color:'#ffffff'}}
            >
              {file.name}
            </Link>
          </Typography>
        ))}
      </Paper>
    </Box>  
  );
};

export default DealDetails;
